import React from 'react'
import { withRouter, Link} from 'react-router-dom';
import Language from '../language/language'
import { inject, observer } from 'mobx-react';
import InvitationCode from '../common/invitationCode'
import { $const } from '../../helper'

import '../applyTeam/stylesheets/applyTeamSuccess.scss'
import './stylesheets/createTeamSuccess.scss'


@inject('teamStore', 'navStore')
@withRouter
@observer
export default class CreateTeamSuccess extends React.Component {
  componentDidMount() {
    if (!this.props.teamStore.createTeamInfo.id) {
      this.props.history.push('/registration-center')
    }
  }
  handleToCenter = () => {
    this.props.navStore.changeNavigation("/control-center")
  }
  render () {
    if (!this.props.teamStore.createTeamInfo.id) {
      return null
    }
    return (
      <div className="apply-team-success create-team-success">
        <div className="title">
          <Language resource="CREATE_TEAM_SUCCESS" />
        </div>
        <div className="sub-title">
          <Language resource="YOU_APPLYED" />
        </div>
        <div className="team-name">
          {`${this.props.teamStore.createTeamInfo.collegeName}  ${this.props.teamStore.createTeamInfo.name}`}
          {this.props.teamStore.createTeamInfo.teamType === $const.TEAM_TYPE.TEAM
             ? <Language resource="TEAM" />
             : <Language resource="CONSORTIUM" />
          }
        </div>
        <div className="sub-title">
          <Language resource="YOU_INVITATION_CODE" />
        </div>
        <InvitationCode code={this.props.teamStore.createTeamInfo.inviteCode} />
        <div className="sub-title">
          <Language resource="CREATE_TEAM_SUCCESS_TIP" />
          <a href="https://www.robomaster.com" target="_blank" rel="noopener noreferrer">
            www.robomaster.com
          </a>
          <Language resource="CREATE_TEAM_SUCCESS_TIP2" />
        </div>
        <div className="sub-title">
          <Language resource="YOU_CAN2"></Language>
          <Link onClick={this.handleToCenter} to="/control-center">
            <Language resource="CONTROL_CENTER"></Language>
          </Link>
          {" "}<Language resource="CANTROL_YOUR_TEAM"></Language>
        </div>

        <Link to="/registration-center">
          <Language resource="RETURN_REGISTRATION_CENTER" />
        </Link>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/createTeam/createTeamSuccess.js